import { gql } from "@apollo/client";

export const CREATE_QUEUE_RECORD_MUTATION = gql`
  mutation CreateQueueRecord($input: CreateQueueRecordInput!) {
    createQueueRecord(input: $input) {
      success
      messageId
      error
    }
  }
`;
